module.exports = __webpack_public_path__ + "media/images/round-preloader-ed8ec5f333d01abcb398fdb756912a51.gif";